import SkeletonTable from "@/components/SkeletonTable";
import api from "@/lib/axios";
import { useQuery } from "@tanstack/react-query";
import { columns } from "./partial/Columns";
import { DataTable } from "./partial/DataTable";
import { useTahun } from "@/hooks/useTahun";

const getListRekapPesertaSuratKeteranganSehat = async (tahun: String) => {
  const response = await api.get(
    "/setting/verifikator-surat-keterangan-sehat/index",
    {
      withCredentials: true,
      params: { tahun },
    },
  );
  return response.data;
};

export default function SettingVerifikatorSuratKeteranganSehatPage() {
  const { selectedTahun } = useTahun();

  const { data, isPending } = useQuery({
    queryKey: ["listRekapPesertaSuratKeteranganSehat", selectedTahun?.label],
    queryFn: () =>
      getListRekapPesertaSuratKeteranganSehat(selectedTahun?.label),
  });

  if (isPending) return <SkeletonTable />;

  return (
    <div>
      <DataTable data={data?.data || []} columns={columns} />
    </div>
  );
}
